// React import
import React from 'react';
// Styles imports
import './WalletMenu.css';
import '../../util.css'
// Consts imports
import {
    WALLET_TAB_STATS,
    WALLET_TAB_TOKENS,
    WALLET_TAB_BALANCE,
    WALLET_TAB_AI_STATS
} from "../../consts/consts";

class WalletMenu extends React.Component {

    constructor(props) {
        super(props);
    }

    getLabelClass(tab, component){
        if(tab === component) {
            return "check-wallet__select-menu__item-label-active";
        } else {
            return "check-wallet__select-menu__item-label-no-active";
        }
    }

    render () {

        const { tab, statsClick, tokensClick, balanceClick, aiStatsClick } = this.props;

        return(
            <div className={"check-wallet__select-menu noselect"}>
                <span className={this.getLabelClass(tab, WALLET_TAB_STATS)} onClick={statsClick}>Stats</span>
                <span className={this.getLabelClass(tab, WALLET_TAB_TOKENS)} onClick={tokensClick}>Tokens</span>
                <span className={this.getLabelClass(tab, WALLET_TAB_BALANCE)} onClick={balanceClick}>Portfolio</span>
                <span className={this.getLabelClass(tab, WALLET_TAB_AI_STATS)} onClick={aiStatsClick}>AI stats</span>
            </div>
        );
    }

}

export default WalletMenu;